import React from "react";
import TrophyBadge from "./Icons/TrophyBadge";
import StarBadge from "./Icons/StarBadge";
import ThunderBadge from "./Icons/ThunderBadge";
import EmptyBadge from "./Icons/EmptyBadge";
import AllyBadge from "./Icons/AllyBadge";
import MedalBadge from "./Icons/MedalBadge";
import FirstBadge from "./Icons/FirstBadge";
import ConnectionBadge from "./Icons/ConnectionBadge";
import ActionStreakBadge from "./Icons/ActionStreakBadge";
import WisdomBadge from "./Icons/WisdomBadge";

const achievementBadges = {
  streak: (size) => <ThunderBadge size={size} />,
  star: (size) => <StarBadge size={size} />,
  champion: (size) => <TrophyBadge size={size} />,
  ally: (size) => <AllyBadge size={size} />,
  medal: (size) => <MedalBadge size={size} />,
  first: (size) => <FirstBadge size={size} />,
  connection: (size) => <ConnectionBadge size={size} />,
  wisdom: (size) => <WisdomBadge size={size} />,
  actionStreak: (size) => <ActionStreakBadge size={size} />,
  empty: (size) => <EmptyBadge size={size} />,
};

export default achievementBadges;
